import { render, staticRenderFns } from "./help5.vue?vue&type=template&id=5055fcb7&scoped=true"
import script from "./help5.vue?vue&type=script&lang=js"
export * from "./help5.vue?vue&type=script&lang=js"
import style0 from "./help5.vue?vue&type=style&index=0&id=5055fcb7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5055fcb7",
  null
  
)

export default component.exports